import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Store } from '@ngrx/store';
import { fromStore } from 'angular/app/core/store';
import { authActions } from 'angular/app/core/store/auth';
import { User } from '../../../core/models/entities/user';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { take } from 'rxjs/operators';
import { VendorsService } from '../../../core/services/vendors.service';
import { FormValidationService } from '../../../core/services/form-validation.service';
import { ApiError } from '../../../core/models/common/api-error';
import { ToastService } from '../../../core/services/toast.service';

@Component({
  selector: 'app-authentication-settings-page',
  template: `
    <app-page-header title="Mode test"></app-page-header>
    
    <app-spacer size="6"></app-spacer>
    
    <div>
      <app-fieldset>
        <div title>Authentification à 2 facteurs</div>
        <div description
          >L’authentification à 2 facteurs est une sécurité supplémentaire pour
          accéder à votre espace admin.<br /><br />À chaque tentative de
          connexion, vos utilisateurs seront invités à consulter leur boîte
          e-mail et d'utiliser un lien pour se connecter.</div
          >
    
          @if (form) {
            <form class="bg-light rounded-lg p-8">
              <div class="flex items-center">
                <app-toggle
                  [defaultValue]="form.get('two_factor_authentication').value"
              (isEnabled)="
                form.get('two_factor_authentication').patchValue($event)
              "
                  title="Activer l’authentification à 2 facteurs pour tous les utilisateurs"
                ></app-toggle>
                @if (sendingData) {
                  <app-loader class="ml-2" size="sm"></app-loader>
                }
              </div>
            </form>
          }
        </app-fieldset>
      </div>
    `,
  standalone: false,
})
export class AuthenticationSettingsPageComponent implements OnInit, OnDestroy {
  loggedUser$: Observable<User> = this.store.select(fromStore.selectAuthUser);
  form: UntypedFormGroup;
  sendingData = false;
  onDestroy$ = new Subject<void>();

  constructor(
    private store: Store,
    private vendorsService: VendorsService,
    private formValidationService: FormValidationService,
    private toastService: ToastService,
  ) {}

  ngOnInit() {
    this.loggedUser$.pipe(take(1)).subscribe((user) => {
      this.form = new UntypedFormGroup({
        two_factor_authentication: new UntypedFormControl(
          user.vendor.two_factor_authentication,
        ),
      });

      this.form.valueChanges
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((value) => {
          this.submit();
        });
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  async submit() {
    this.loggedUser$.pipe(take(1)).subscribe(async (user) => {
      if (!this.formValidationService.validate(this.form)) return;
      this.sendingData = true;
      try {
        const vendor = await this.vendorsService.updateTwoFactorAuth(
          this.form.value,
        );
        this.toastService.success('Modifications enregistrées.');
        this.store.dispatch(
          authActions.findCurrentUserSuccess({ user: { ...user, vendor } }),
        );
      } catch (exception) {
        this.formValidationService.displayApiValidationErrors(
          this.form,
          exception as ApiError,
        );
      }
      this.sendingData = false;
    });
  }
}
